// using module.exports here so gatsby-config can read it
module.exports = {
  // TODO: Replace next line with your own public API key
  builderAPIKey: '6b3803df32e747fd9bdf64e9a21244d9'
};
